import {
  DatabaseLayoutType,
  isBuiltInDatabaseLayoutType,
} from '@databases/types/database/view';

export function resolveSelectionFeatureLayoutType(
  layoutType: string,
): DatabaseLayoutType | undefined {
  // TODO(CTD-7179): Remove this exception when Timeline becomes a built-in layout.
  if (layoutType === DatabaseLayoutType.TIMELINE) {
    return DatabaseLayoutType.TIMELINE;
  }

  return isBuiltInDatabaseLayoutType(layoutType) ? layoutType : undefined;
}
